import AliyunSLS from './AliyunSLS';
import Elasticsearch from './Elasticsearch';

const LogsDetail = {
  AliyunSLS,
  Elasticsearch,
};

export default LogsDetail;
